"use client";

import { useMemo } from "react";

import React, { useRef, useEffect, useState } from "react";


import { CopilotSidebar } from "@copilotkit/react-ui";
import "@copilotkit/react-ui/styles.css";
import { CopilotKit, useCoAgent, useCoAgentStateRender } from "@copilotkit/react-core";
// import { useCoAgent, useCoAgentStateRender } from '@copilotkit/react-core';
import { useLangGraphInterrupt } from "@copilotkit/react-core"; 

import { AgentState } from "@/lib/types";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";

import { CaseStudySection } from "./landing/sections/case-study-section";
import { SiteHeader } from "./chat/components/site-header";
import { Ray } from "./landing/components/ray";
import { Jumbotron } from "./landing/components/jumbotron";
import { JoinCommunitySection } from "./landing/sections/join-community-section";

// import { useState } from "react";
import { CopilotTextarea } from "@copilotkit/react-textarea";
import "@copilotkit/react-textarea/styles.css";
import { Reply } from "./chat/components/Reply";


export default function Home() {

  const [text, setText] = useState("");

  // 只渲染 JoinCommunitySection，不再管理登录注册状态
  return (
    <div className="flex flex-col items-center min-h-screen bg-black">
      <SiteHeader />
      <main className="container flex flex-col items-center justify-center gap-56">

        <CaseStudySection />
        <JoinCommunitySection />
      </main>
      <Footer />
      <Ray />
    </div>
  );
}


function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);
  return (
    <footer className="container mt-32 flex flex-col items-center justify-center">
      <hr className="from-border/0 via-border/70 to-border/0 m-0 h-px w-full border-none bg-gradient-to-r" />
      <div className="text-muted-foreground container flex h-20 flex-col items-center justify-center text-sm">
        <p className="text-center font-serif text-lg md:text-xl">
          &quot;Originated from Open Source, give back to Open Source.&quot;
        </p>
      </div>
      <div className="text-muted-foreground container mb-8 flex flex-col items-center justify-center text-xs">
        <p>Licensed under MIT License</p>
        <p>&copy; {year} BioAgent</p>
      </div>
    </footer>
  );
}